import { render, staticRenderFns } from "./AgendamentoEntrega.vue?vue&type=template&id=1f22b7e4&"
import script from "./AgendamentoEntrega.vue?vue&type=script&lang=js&"
export * from "./AgendamentoEntrega.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports